import {AbstractPlayableContent, TemporalIndicators} from "./AbstractPlayableContent";
import {defaultPiece, type Piece} from "./Piece";
import {type Section} from "./Section";
import {LoopParameters} from "../../player/models/parameters/LoopParameters";
import {VisualParameters} from "../../player/models/parameters/VisualParameters";
import {defaultVolumes, SoundParameters} from "../../player/models/parameters/SoundParameters";
import {type DiscreteTempo, getDiscreteTempo} from "../../global/types/DiscreteTempo";
import {computePlayableTimeline} from "../utils/PlayableFactory";
import { type PlayerConfigState } from "../../player/models/PlayerConfig";

export class Challenge extends AbstractPlayableContent {
  readonly piece: Piece;

  // TODO might be readonly
  difficulty: number = 3;

  constructor(piece: Piece, id: number, sectionTimeline: Section[], temporalIndicators: TemporalIndicators, baseModel: any) {
    super('challenge', id, piece.title + ' - ' + baseModel.title, temporalIndicators, baseModel, sectionTimeline);

    this.piece = piece;
  }

  public getPlayerConfig(): PlayerConfigState {
    return {
      playerView: 'piano',
      playerMode: 'normal',
      speed: getDiscreteTempo(this.temporalIndicators.tempo, this.baseModel.config.start_tempo as DiscreteTempo),

      loopParameters: new LoopParameters('PLAY', this),
      visualParameters: VisualParameters.fromHandConfiguration(this.baseModel.config.hand_type, true),
      soundParameters: new SoundParameters(
        {
          MAIN: true,
          LEFT: true,
          RIGHT: true,
          MELODY: true,
          METRONOME: true,
        },
        defaultVolumes
      ),
    };
  }

  public getAnalyticsData() {
    return {
      type: 'challenge',
      piece: this.piece,
      challengeId: this.id,
      name: this.name,
    }
  }

  static createFromChallengeJson(challengeJson: any) {
    const temporalIndicators = new TemporalIndicators(0, challengeJson.division_qty, challengeJson.division_per_beat, challengeJson.beat_per_measure, challengeJson.sections[0].tempo);
    const sectionTimeline = computePlayableTimeline(challengeJson.section_timeline, 'section') as Section[];

    const challenge = new Challenge(challengeJson.piece_version.piece, challengeJson.id, sectionTimeline, temporalIndicators, challengeJson);
    challenge.difficulty = challengeJson.difficulty;

    return challenge;
  }
}

export const defaultChallenge = new Challenge(defaultPiece, -1, [], new TemporalIndicators(), {title: 'challenge', config: {hand_type: 'BOTH_HAND'}})



